import { FC, memo, useState } from 'react';
import { Gender } from 'types/register';
import { ButtonsSet } from 'modules/RegisterModule/components/ButtonsSet';
import { OptionsGroup } from 'modules/RegisterModule/components/OptionsGroup';
import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { useBreakpoints } from 'hooks/useBreakpoints';

import { getTruncatedText } from '../../helpers';
export interface Step3Props {
  onSubmit: (gender: Gender) => void;
  prevStep: () => void;
  employeeName: string;
  gender: string;
}

export const Step3: FC<Step3Props> = memo(
  ({ onSubmit, prevStep, employeeName, gender }) => {
    const { isUpTablet } = useBreakpoints();

    const [selectedGender, setSelectedGender] = useState(
      gender.charAt(0).toUpperCase() + gender.slice(1)
    );

    const handleGenderChange = (value: string) => {
      setSelectedGender(value);
    };

    return (
      <Box className="flex flex-1 flex-col items-center justify-center">
        <Typography
          variant="pSemiBold"
          className="mt-8 max-w-[44rem] break-words text-center text-[28px] md:text-[32px]"
        >
          Since you will be able to talk to{' '}
          {getTruncatedText(isUpTablet, employeeName)} during these
          demonstrations, what gender would you like to use?
        </Typography>
        <OptionsGroup
          data={['Male', 'Female', 'Neutral']}
          onClick={(value) => handleGenderChange(value)}
          selectedValue={selectedGender}
        />
        <ButtonsSet
          onBack={prevStep}
          onNext={() => onSubmit(selectedGender.toLowerCase() as Gender)}
        />
      </Box>
    );
  }
);
